import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'About ShipSkis: Created by Skiers for Skiers',
  description:
    'Learn all about ShipSkis - the best way to ship skis and snowboards ' +
    'to the mountain and back again.',
  alternates: {
    canonical: 'https://www.shipskis.com/about',
  },
}

export default metadata
